import React from "react";
import Home from "./container/Home";
function App() {
  return (
    <>
      <Home />
    </>
  );
}

export default App;
